import { StudioLogger } from '@studio/logger/StudioLogger';

import { createMeeting } from '@shoflo/studio-redux/actions';
import { withCurrentParams } from 'actions/utils';
import { BROADCAST_UPDATE_KNOCK } from 'actions/Types';
import { getUpdateKnockLogPayload } from 'utils/loggingUtils';

const logger = new StudioLogger('knocks');

export default (knock, changes) => {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, getState) => {
      const { meeting } = getState();
      const { status } = changes;

      const action = {
        type: BROADCAST_UPDATE_KNOCK,
        request: async apiClient => {
          const {
            name,
            _id: knockId,
            presenterId,
            type,
            sourceId,
            ...restKnockData
          } = knock;
          const { broadcast, ...restResponse } =
            await apiClient.broadcastKnock.updateKnockRequest(
              teamId,
              eventId,
              broadcastId,
              knockId,
              { name, presenterId, type, status }
            );

          return {
            broadcastId: broadcast,
            sourceId,
            ...restKnockData,
            ...restResponse
          };
        }
      };

      dispatch(action);

      const logPayload = getUpdateKnockLogPayload(knock, changes, meeting);

      logger.info(logPayload.title, logPayload);

      if (!meeting.started) {
        dispatch(createMeeting());
      }
    }
  );
};
